import React from "react";
import classes from "./PageSummary.module.css";

const TrainingPageSummary = (props) => {
  return (
    <section className={classes.summary}>
      <h2 style={{ fontWeight: "bold" }}>
        Welcome {props.name + " "}to the @one Alliance Project Viewer Training
        Page
      </h2>
      <p>This training page is for the Engineering Team</p>
      <p>
        Please select your current role from the dropdown menu. Once you have
        selected a role the courses will be populated below
      </p>
      {/* <p>Once you have selected a role the courses will be populated below</p> */}
      <p>
        For all questions, or to tell us what you think, please contact
        oneengineering@anglianwater.co.uk.
      </p>
    </section>
  );
};

export default TrainingPageSummary;
